<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="15vh"
    :modal-append-to-body="false"
    :before-close="handleClose"
    custom-class="custom-dialog-class"
  >
    <div class="flex flex-col pb-5 items-center">
      <div class="flex justify-center"><check-mark-icon /></div>
      <p class="text-base font-bold pt-2">Beneficiary Saved</p>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  name: 'BeneficiarySavedSuccessDialog',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints
    }
  },
  methods: {
    handleClose () {
      this.$router.push('transactions')
      this.$emit('closeDialog')
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '20%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  components: {
    CheckMarkIcon: () => import('@/assets/icons/CheckMarkIcon.vue')
  }
}
</script>

<style scoped>
@media screen and (min-width: 1280px) {
  >>> .custom-dialog-class {
    margin-left: 46vw;
  }
}
</style>
